import React from "react";

const Question = ({ children }) => {
  return <p className="item-1">{children}</p>;
};

export default Question;
